module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-checkbox p-component",
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "p-hidden-accessible"
  }, [_c('input', {
    ref: "input",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.checked
    },
    on: {
      "focus": function($event) {
        return _vm.onFocus($event)
      },
      "blur": function($event) {
        return _vm.onBlur($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    ref: "box",
    class: ['p-checkbox-box p-component', {
      'p-highlight': _vm.checked,
      'p-disabled': _vm.$attrs.disabled,
      'p-focus': _vm.focused
    }],
    attrs: {
      "role": "checkbox",
      "aria-checked": _vm.checked
    }
  }, [_c('span', {
    class: ['p-checkbox-icon', {
      'pi pi-check': _vm.checked
    }]
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-506cd370"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/datatable/RowCheckbox.vue
// module id = 2227
// module chunks = 0